// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1faE5","notes":"Notes_notes__2FI21","note":"Notes_note__pNE9z","markdown":"Notes_markdown__3vGvR"};